import { gql } from "__generated__/gql";

export const documentFragment = gql(`#graphql
	fragment documentFragment on Document {
		id
		created
		issuedAt
		active
		description
		documentEntity
		filename
		type
		documentEntity
		documentType
		validUntil
		status
		lastStatusUpdateOn
		cargoActionId
		cargo {
			id
			cargoNumber
			containerNumber
			product {
				id
				name
				description
			}
		}
		voyage {
			id
			voyageNumber
			inactivityType
			ship {
				id
			}
		}
		charter {
			id
			charterNumber
			type
		}
	}
`);

export const availabilityFragment = gql(`#graphql
	fragment availabilityFragment on ShipAvailability {
		availableSunday
		availableMonday
		availableTuesday
		availableWednesday
		availableThursday
		availableFriday
		availableSaturday
		availableDayNight
		availableHoursADay
		defaultAvailability
	}
`);

export const agreementFragment = gql(`#graphql
fragment agreementFragment on Agreement {
	id
	type
	invoiceGroupType {
		id
		name
	}
	... on ShipAgreement {
		ships {
			id
			name
			owner {
				id
				name
			}
		}
	}
	calculationMethod {
		id
		type
		description
		price
		... on DemurrageCalculationCalculationMethod {
			laytimeRoundingRule
			laytimeRoundingUnit
			laytimeRoundingScope
			laytimePeriodRegime
			demurrageCalculationUnit
			laytimeAllowed
			defaultCargoActionTypes
		}
	}
}
`);

export const parentContractFragment = gql(`#graphql
fragment parentContractFragment on Contract {
	id
	contractNumber
	agreements {
		...agreementFragment
	}
}
`);

export const charterContractFragment = gql(`#graphql
fragment charterContractFragment on Contract {
	id
	contractNumber
	versionNumber
	charterType
	charterSubtype
	status {
		name
		color
		languageKeyPrefix
	}
	isEditable
	description
	memo
	noticePeriod
	validFrom
	validUntil
	statusUpdatedOn
	allIn
	includePricingInNomination
	labels {
		id
		text
		type
		color
	}
	agreements {
		...agreementFragment
	}
	currency {
		isoCode
		rate
		symbol
	}
	creditor {
		id
		name
		email
		applicationRelation
		customer
		operator
		shipManger
		isShipManager
		supplier
		address {
			street
			zipCode
			town
			country
		}
		contacts {
			id
			type
			name
			insertion
			surName
			email
		}
	}
	debtor {
		id
		name
		email
		applicationRelation
		customer
		operator
		shipManger
		isShipManager
		supplier
		address {
			street
			zipCode
			town
			country
		}
		contacts {
			id
			type
			name
			insertion
			surName
			email
		}
	}
	creditorContact {
		id
		name
	}
	debtorContact {
		id
		name
	}
	documents {
		id
		description
		type
		documentEntity
		filename
	}
	comments {
		...comment
	}
	charters {
		id
	}
	isParentContract
	parentContract {
		...parentContractFragment
	}
	agreementsHaveChanged
	termsAndConditions {
		id
		description
	}
}
`);

export const staffelItemFragment = gql(`#graphql
	fragment staffelItemFragment on StaffelItem {
		id
		discriminator
		staffel {
			id
			description
			discriminator
		}
		... on PriceStaffelItem {
			price
		}
		... on SurchargeStaffelItem {
			surcharge
		}
		... on FeetStaffelItem {
			startFeet
			endFeet
			reefer
			empty
		}
		... on GasolineStaffelItem {
			startPrice
			endPrice
		}
		... on WaterLevelStaffelItem {
			startWaterLevelCm
			endWaterLevelCm
		}
	}
`);

export const staffelFragment = gql(`#graphql
	fragment staffelFragment on Staffel {
		id
		description
		discriminator
		staffelItems {
			...GeneralStaffelItem
		}
		... on WaterLevelStaffel {
			waterlevelMeasuringPoint
		}
	}
`);
